/** Socket.IO event names — must match server / legacy dashboard exactly. */
export const DASH_SOCKET_EVENTS = {
  subscribe: "dash:subscribe",
  snapshot: "dash:snapshot",
  status: "dash:status",
  getSnapshot: "dash:get_snapshot",
  selectSite: "admin:selectSite",
  auditEvent: "audit:event",
  logsAppend: "logs:append",
  logsEngagement: "logs:engagement",
  firewallAppend: "firewall:append",
  usersUpdate: "users:update",
  redirectsAppend: "redirects:append",
  redirectsCleared: "redirects:cleared",
  redirectsDeleted: "redirects:deleted",
  formsAppend: "forms:append",
  formsCleared: "forms:cleared",
  formsUpdated: "forms:updated",
  originEvent: "origin:event",
  originHealth: "origin:health",
  queueChanged: "queue:changed",
  preloadStatus: "preload:status",
  preloadProgress: "preload:progress",
  siteStructureUpdate: "site-structure:update",
  deployProgress: "deploy:progress",
  discoveryProgress: "tenants:discovery:progress",
  leadsGroupsChanged: "leads:groups:changed",
  leadsChanged: "leads:changed",
  userEventsAppend: "user:events:append",
  userState: "user_state",
  userEvent: "user_event",
  watchUser: "watch_user",
  unwatchUser: "unwatch_user"
} as const;

/** Sitewrap Assistant — real-time progress + streamed reply */
export const DASH_PAGES_EVENTS = {
  aiProgress: "pages:ai:progress",
  editorAiProgress: "pages:editor-ai:progress"
} as const;

export const DASH_ASSISTANT_EVENTS = {
  history: "assistant:history",
  chat: "assistant:chat",
  progress: "assistant:progress",
  delta: "assistant:delta",
  done: "assistant:done",
  error: "assistant:error"
} as const;

export const DASH_SUBSCRIBE_TOPICS = [
  "status",
  "logs",
  "firewall",
  "users",
  "redirects",
  "forms",
  "leads",
  "user_events",
  "queue",
  "preload"
] as const;

export type DashSubscribeTopic = (typeof DASH_SUBSCRIBE_TOPICS)[number];
